// extracted by mini-css-extract-plugin
export var container = "names-module--container--K9B55";